import { useEffect, useState } from "react";

// Small photo box in the vehicle lists: the 320px thumbnail, falling back to the full photo if it's missing
const ListThumb = ({ thumb, full, className, style }) => {
  const [src, setSrc] = useState(thumb || full);

  useEffect(() => {
    setSrc(thumb || full);
  }, [thumb, full]);

  return (<img
    src={src}
    alt=""
    loading="lazy"
    className={className}
    style={style}
    onError={() => { if (full && src !== full) setSrc(full); }}
  />);
};

export default ListThumb;
